@if (paymentPlan) {
    <card-component>
        <card-title title="Confirmation"></card-title>
        <card-content>
            <h1 [ngStyle]="{ 'text-align': 'center', 'font-size': '100px', color: '#28a745' }">
                <i class="fa-solid fa-circle-check"></i>
            </h1>
            <table class="table table-hover" [ngStyle]="{ width: '100%' }">
                <tbody>
                    @for (instalment of paymentPlan.instalments; track instalment) {
                        <tr>
                            <td>
                                <date-time-component-inner
                                    [date]="instalment.due_date.toISOString()"
                                    [timezone]="systemConfigService.config.timezone"
                                ></date-time-component-inner>
                            </td>
                            <td>
                                <base-currency-component
                                    [currency]="paymentPlan.currency"
                                    [value]="instalment.amount"
                                    [locale]="systemConfigService.config.locale"
                                    [precision]="order.currency_precision"
                                ></base-currency-component>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
            <div>
                <raised-button color="primary" (click)="viewOrders()" [styles]="{ width: '100%' }">View Orders</raised-button>
            </div>
        </card-content>
    </card-component>

}
